import { render, staticRenderFns } from "./DirectoryMyBusiness.vue?vue&type=template&id=5a88c1e6&"
import script from "./DirectoryMyBusiness.vue?vue&type=script&lang=js&"
export * from "./DirectoryMyBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CASADEDIOS\\git\\global_business\\gpb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a88c1e6')) {
      api.createRecord('5a88c1e6', component.options)
    } else {
      api.reload('5a88c1e6', component.options)
    }
    module.hot.accept("./DirectoryMyBusiness.vue?vue&type=template&id=5a88c1e6&", function () {
      api.rerender('5a88c1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/frontend/js/components/DirectoryMyBusiness.vue"
export default component.exports